<template>
  <div class="home-container">
    <!-- Hero / Welcome Section -->
    <section class="hero-section">
      <div class="hero-content">
        <div class="logo-wrapper">
          <img src="@/assets/platform/m3d-icon.svg" alt="M3D HUB" class="hero-logo" />
        </div>
        <h1 class="hero-title">M3D Semiconductor Hub</h1>
        <p class="hero-subtitle">Monolithic 3D Integration(M3D) 반도체 소재·공정 데이터 허브에 오신 것을 환영합니다.<br/>혁신적인 반도체 소재 연구를 위한 데이터 통합 솔루션을 경험해보세요.</p>
      </div>
    </section>

    <!-- Service Menu Cards -->
    <section class="services-section">
      <div class="section-container">
        <div class="menu-cards">
          <div class="menu-card" @click="handleClick('experiment')">
            <div class="card-icon experiment"></div>
            <div class="card-body">
              <h3 class="menu-title">실험입력</h3>
              <p class="menu-description">실험 데이터를 체계적으로 관리하고<br/>신규 내용을 입력해보세요.</p>
            </div>
            <div class="card-footer">
              <i class="arrow-icon"></i>
            </div>
          </div>

<!--          <div class="menu-card" @click="handleClick('protocol')">-->
<!--            <div class="card-icon protocol"></div>-->
<!--            <div class="card-body">-->
<!--              <h3 class="menu-title">프로토콜 생성</h3>-->
<!--              <p class="menu-description">프로토콜을 생성하고 편집하며<br/>Hub API 동작을 확인해보세요.</p>-->
<!--            </div>-->
<!--            <div class="card-footer">-->
<!--              <span class="action-text">바로가기</span>-->
<!--              <i class="arrow-icon"></i>-->
<!--            </div>-->
<!--          </div>-->

          <div class="menu-card" @click="handleClick('develope')">
            <div class="card-icon calculation"></div>
            <div class="card-body">
              <h3 class="menu-title">계산입력</h3>
              <p class="menu-description">고도화된 계산 알고리즘을 통한<br/>데이터 분석을 진행해보세요.</p>
            </div>
            <div class="card-footer">
              <i class="arrow-icon"></i>
            </div>
          </div>

          <div class="menu-card" @click="handleClick('visualization')">
            <div class="card-icon visualization"></div>
            <div class="card-body">
              <h3 class="menu-title">시각화</h3>
              <p class="menu-description">실험·계산 데이터의 연관관계와<br/>지식그래프를 탐색해 보세요.</p>
            </div>
            <div class="card-footer">
              <i class="arrow-icon"></i>
            </div>
          </div>

          <div class="menu-card" @click="handleClick('matdb')">
            <div class="card-icon ai"></div>
            <div class="card-body">
              <h3 class="menu-title">문헌·계산과학 데이터 검색</h3>
              <p class="menu-description">반도체 소재의 문헌 및 계산과학 데이터를<br/>탐색·스크리닝하고 Mobility를 예측해 보세요.</p>
            </div>
            <div class="card-footer">
              <i class="arrow-icon"></i>
            </div>
          </div>

          <div class="menu-card" @click="handleClick('literature')">
            <div class="card-icon literature"></div>
            <div class="card-body">
              <h3 class="menu-title">문헌 수집</h3>
              <p class="menu-description">논문 DOI 등록·추출 데이터 업로드,<br/>수집된 문헌 데이터를 검색·시각화해 보세요.</p>
            </div>
            <div class="card-footer">
              <i class="arrow-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Partner Organizations -->
    <section class="partners-section">
      <div class="section-container">
        <h4 class="partner-heading">PARTNERS</h4>
        <div class="partner-list">
          <a href="https://www.etri.re.kr/" target="_blank" class="partner-link" data-tooltip="한국전자통신연구원">
            <img src="@/style/new/images/partners/ETRI.png" alt="ETRI" class="partner-logo" />
          </a>
          <a href="https://www.krict.re.kr/" target="_blank" class="partner-link" data-tooltip="한국화학연구원">
            <img src="@/style/new/images/partners/KRICT.png" alt="KRICT" class="partner-logo" />
          </a>
          <a href="https://www.kist.re.kr/" target="_blank" class="partner-link" data-tooltip="한국과학기술연구원">
            <img src="@/style/new/images/partners/KIST.png" alt="KIST" class="partner-logo" />
          </a>
          <a href="https://www.dongguk.edu/" target="_blank" class="partner-link" data-tooltip="동국대학교">
            <img src="@/style/new/images/partners/DGU.png" alt="DGU" class="partner-logo" />
          </a>
          <a href="https://www.hnu.kr/" target="_blank" class="partner-link" data-tooltip="한남대학교">
            <img src="@/style/new/images/partners/HNU.png" alt="HNU" class="partner-logo" />
          </a>
          <a href="https://www.inu.ac.kr/" target="_blank" class="partner-link" data-tooltip="인천대학교">
            <img src="@/style/new/images/partners/INU.png" alt="INU" class="partner-logo" />
          </a>
          <a href="https://www.dankook.ac.kr/" target="_blank" class="partner-link" data-tooltip="단국대학교">
            <img src="@/style/new/images/partners/DKU.png" alt="DKU" class="partner-logo" />
          </a>
          <a href="https://www.khu.ac.kr/" target="_blank" class="partner-link" data-tooltip="경희대학교">
            <img src="@/style/new/images/partners/KHU.png" alt="KHU" class="partner-logo" />
          </a>
          <a href="https://www.skku.edu/" target="_blank" class="partner-link" data-tooltip="성균관대학교">
            <img src="@/style/new/images/partners/SKKU.png" alt="SKKU" class="partner-logo" />
          </a>
          <a href="https://www.postech.ac.kr/" target="_blank" class="partner-link" data-tooltip="포항공과대학교">
            <img src="@/style/new/images/partners/POSTECH.png" alt="POSTECH" class="partner-logo" />
          </a>
          <a href="https://www.pusan.ac.kr/" target="_blank" class="partner-link" data-tooltip="부산대학교">
            <img src="@/style/new/images/partners/PNU.png" alt="PNU" class="partner-logo" />
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import getToken from "@/plugins/wApi/lib/getToken";

export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  async mounted() {
    const tokenData = getToken();
    const token = tokenData.Authorization;
    if (!token || !this.isTokenValid(token.split(' ')[1])) {
      this.$router.push("/account/login");
      return;
    }
  },
  methods: {
    handleClick(gbn) {
      if (gbn == 'matdb') {
        // 데이터 검색: 문헌 및 계산과학 데이터 검색 (public/matdb 정적 앱). 편집 기능이 아니므로
        // 역할 제한 없이 로그인 사용자 누구나 열 수 있다. 새 탭이 아니라 같은 탭에서 이동(뒤로가기로 홈 복귀).
        // 끝 슬래시 필수 (/m3dhub/matdb/).
        location.href = process.env.BASE_URL + "matdb/";
      } else if (gbn == 'visualization') {
        // 시각화: 데이터 시각화 페이지(/data-visualization 데이터 연관관계·지식그래프). 편집 기능이 아니므로 로그인 사용자 누구나
        // (2026-10-20 주소 정리, KESH 와 동일 체계). 레거시 시각화 게이트(/visualization/gate)는 홈·GNB 에서 연결하지 않는다. /ai 는 AI 카드용으로 비워 둔다.
        this.$router.push("/data-visualization");
      } else if (gbn == 'literature') {
        // 문헌 수집: 로그인 사용자 누구나 (2026-10-05 결정 — KESH 와 동일하게 홈 동등 카드)
        this.$router.push("/literature");
      } else if (!this.user.admin && !this.user.assistant && !this.user.committee && !this.user.super && !this.user.generalManager) {
        window.alert("일반 유저는 에디터 접근이 불가합니다.");
      } else if (gbn == 'experiment') {
        window.open(this.$router.resolve("/experiment/gate?editorType=gate").href);
      } else if (gbn == 'protocol') {
        window.open(this.$router.resolve("/protocol/gate?editorType=gate&listSearchType=recentList").href);
      } else if (gbn == 'develope') {
        window.alert("개발중입니다.");
      }
    },
    isTokenValid(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        return payload.exp > currentTime;
      } catch (e) {
        return false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  /* .wrap의 padding(top: 70px, bottom: 104px)을 고려하여 최소 높이 설정 */
  min-height: calc(100vh - 174px);
  background-color: #f8fafc;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, system-ui, Roboto, sans-serif;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
  padding: 60px 0 40px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.logo-wrapper {
  margin-bottom: 24px;
}

.hero-logo {
  height: 150px;
  object-fit: contain;
}

.hero-title {
  font-size: 48px;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: 18px;
  color: #64748b;
  line-height: 1.6;
  font-weight: 400;
}

/* Services Section */
.services-section {
  padding: 40px 0;
}

.menu-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}

.menu-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 32px 24px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  box-shadow: none;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-color: #3b82f6;

    .card-footer .action-text {
      color: #3b82f6;
    }

    .card-footer .arrow-icon {
      transform: translateX(4px);
      border-color: #3b82f6;
    }
  }
}

.card-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  margin-bottom: 24px;
  background-color: #f1f5f9;
  background-size: 36px;
  background-repeat: no-repeat;
  background-position: center;

  &.experiment {
    background-color: #eff6ff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%233b82f6'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' /%3E%3C/svg%3E");
  }
  &.protocol {
    background-color: #eef2ff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234f46e5'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 12h6m-6 4h6M7 4h10a2 2 0 012 2v14l-4-2-4 2-4-2-4 2V6a2 2 0 012-2z' /%3E%3C/svg%3E");
  }
  &.calculation {
    background-color: #fdf2f8;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23ec4899'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z' /%3E%3C/svg%3E");
  }
  &.visualization {
    background-color: #f0fdf4;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2322c55e'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' /%3E%3C/svg%3E");
  }
  &.ai {
    background-color: #f5f3ff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%238b5cf6'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13 10V3L4 14h7v7l9-11h-7z' /%3E%3C/svg%3E");
  }

  &.literature {
    background-color: #f0fdfa;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%230d9488'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' /%3E%3C/svg%3E");
  }
}

.menu-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.menu-description {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 24px;
}

.card-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-text {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  transition: color 0.2s;
}

.arrow-icon {
  width: 7px;
  height: 7px;
  border-top: 2px solid #cbd5e1;
  border-right: 2px solid #cbd5e1;
  transform: rotate(45deg);
  transition: all 0.2s;
}

/* Partners Section */
.partners-section {
  padding: 30px 0 0;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.partner-heading {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.1em;
  text-align: center;
  margin-bottom: 24px;
}

.partner-list {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 32px;
}

.partner-link {
  display: block;
  opacity: 0.6;
  filter: grayscale(1);
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    opacity: 1;
    filter: grayscale(0);
    transform: translateY(-2px);

    &::after {
      content: attr(data-tooltip);
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 10px;
      padding: 8px 12px;
      background-color: rgba(30, 41, 59, 0.9);
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      border-radius: 6px;
      white-space: nowrap;
      z-index: 10;
      pointer-events: none;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    }

    &::before {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 4px;
      border-width: 6px;
      border-style: solid;
      border-color: rgba(30, 41, 59, 0.9) transparent transparent transparent;
      z-index: 10;
      pointer-events: none;
    }
  }
}

.partner-logo {
  height: 28px;
  width: auto;
  object-fit: contain;
}

/* Responsive */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 36px;
  }
  .menu-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 60px 0;
  }
  .hero-title {
    font-size: 28px;
  }
  .hero-subtitle {
    font-size: 16px;
  }
  .menu-cards {
    grid-template-columns: 1fr;
  }
  .partner-list {
    gap: 24px;
  }
  .partner-logo {
    height: 20px;
  }
}
</style>